requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (customElements.get('product-notifications')) return;

    class ProductNotifications extends HTMLElement {
      constructor() {
        super();
        this.items = [];
        this.queue = [];
        this.timer = null;
        this.intervalMin = 5;
        this.intervalMax = 10;
        this.mode = 'after_open';
        this.locations = [];
        this.timeTemplate = '';
        this.leadText = '';
        this.boundHandleClose = this.handleClose.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.items = Array.from(this.querySelectorAll('[data-popup-item]'));
        if (!this.items.length) {
          this.initialized = false;
          return;
        }

        this.intervalMin = Number(this.dataset.intervalMin) || 5;
        this.intervalMax = Number(this.dataset.intervalMax) || this.intervalMin + 5;
        this.onloadInterval = this.dataset.onloadInterval ? Number(this.dataset.onloadInterval) : null;
        this.mode = this.dataset.mode || 'after_open';
        this.locations = (this.dataset.locations || '').split('|').map((city) => city.trim()).filter(Boolean);
        this.timeTemplate = this.dataset.timeTemplate || '';
        this.leadText = this.dataset.leadText || '';

        this.items.forEach((item) => {
          const closeButton = item.querySelector('[data-popup-close]');
          if (closeButton) {
            closeButton.addEventListener('click', this.boundHandleClose);
          }
        });

        this.initialized = true;
        this.startTimer(this.dataset.onloadInterval ? Number(this.dataset.onloadInterval) * 1000 : undefined);
      }

      disconnectedCallback() {
        this.clearTimer();
        this.items.forEach((item) => {
          const closeButton = item.querySelector('[data-popup-close]');
          if (closeButton) {
            closeButton.removeEventListener('click', this.boundHandleClose);
          }
        });
        this.initialized = false;
      }

      handleClose(event) {
        const item = event.currentTarget?.closest('[data-popup-item]');
        if (!item) return;
        item.classList.remove('is-active');
        if (this.mode === 'after_close') {
          this.startTimer();
        }
      }

      startTimer(manualDelay) {
        this.clearTimer();
        const delay = manualDelay === undefined ? this.getNextDelay() : manualDelay;
        this.timer = window.setTimeout(() => this.showNext(), delay);
      }

      clearTimer() {
        if (this.timer) {
          window.clearTimeout(this.timer);
          this.timer = null;
        }
      }

      getNextDelay() {
        const min = Math.max(1, this.intervalMin);
        const max = Math.max(min, this.intervalMax);
        return (Math.random() * (max - min) + min) * 1000;
      }

      getMinutesSample() {
        return Math.floor(Math.random() * 55) + 5;
      }

      pickLocation() {
        if (!this.locations.length) return '';
        const index = Math.floor(Math.random() * this.locations.length);
        return this.locations[index];
      }

      buildQueue() {
        this.queue = this.items.map((_, index) => index);
        for (let i = this.queue.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [this.queue[i], this.queue[j]] = [this.queue[j], this.queue[i]];
        }
      }

      showNext() {
        if (!this.queue.length) {
          this.buildQueue();
        }

        const nextIndex = this.queue.shift();
        const nextItem = typeof nextIndex === 'number' ? this.items[nextIndex] : null;
        if (!nextItem) return;

        this.items.forEach((item) => item.classList.remove('is-active'));
        this.populateItem(nextItem);
        nextItem.classList.add('is-active');

        if (this.mode === 'after_open') {
          this.startTimer();
        }
      }

      populateItem(item) {
        const minutes = this.getMinutesSample();
        const location = this.pickLocation() || '';
        const leadEl = item.querySelector('[data-popup-lead]');
        const timeEl = item.querySelector('[data-popup-time]');

        if (leadEl && this.leadText) {
          leadEl.textContent = this.leadText;
        }

        if (timeEl) {
          const rawTemplate = this.timeTemplate || '';
          const filled = rawTemplate
            .replace('[minutes]', minutes)
            .replace('[location]', location);
          timeEl.textContent = filled;
        }
      }
    }

    customElements.define('product-notifications', ProductNotifications);
  });
});